// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ISearchEmployeeInfoDto
 */
export interface ISearchEmployeeInfoDto {
    /**
     * 
     * @type {number}
     * @memberof ISearchEmployeeInfoDto
     */
    employee_id?: number;
    /**
     * 
     * @type {string}
     * @memberof ISearchEmployeeInfoDto
     */
    first_name?: string;
    /**
     * 
     * @type {string}
     * @memberof ISearchEmployeeInfoDto
     */
    last_name?: string;
    /**
     * 
     * @type {string}
     * @memberof ISearchEmployeeInfoDto
     */
    employer_employee_id?: string;
    /**
     * 
     * @type {string}
     * @memberof ISearchEmployeeInfoDto
     */
    partner_employee_id?: string;
    /**
     * 
     * @type {string}
     * @memberof ISearchEmployeeInfoDto
     */
    ssn?: string;
    /**
     * 
     * @type {string}
     * @memberof ISearchEmployeeInfoDto
     */
    status?: ISearchEmployeeInfoDtoStatusEnum;
}

/**
* @export
* @enum {string}
*/
export enum ISearchEmployeeInfoDtoStatusEnum {
    A = 'A',
    T = 'T',
    L = 'L',
    R = 'R',
    F = 'F',
    C = 'C'
}


/**
 * Check if a given object implements the ISearchEmployeeInfoDto interface.
 */
export function instanceOfISearchEmployeeInfoDto(value: object): value is ISearchEmployeeInfoDto {
    return true;
}

export function ISearchEmployeeInfoDtoFromJSON(json: any): ISearchEmployeeInfoDto {
    return ISearchEmployeeInfoDtoFromJSONTyped(json, false);
}

export function ISearchEmployeeInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ISearchEmployeeInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'employee_id': json['employeeId'] == null ? undefined : json['employeeId'],
        'first_name': json['firstName'] == null ? undefined : json['firstName'],
        'last_name': json['lastName'] == null ? undefined : json['lastName'],
        'employer_employee_id': json['employerEmployeeId'] == null ? undefined : json['employerEmployeeId'],
        'partner_employee_id': json['partnerEmployeeId'] == null ? undefined : json['partnerEmployeeId'],
        'ssn': json['ssn'] == null ? undefined : json['ssn'],
        'status': json['status'] == null ? undefined : json['status'],
    };
}

export function ISearchEmployeeInfoDtoToJSON(json: any): ISearchEmployeeInfoDto {
    return ISearchEmployeeInfoDtoToJSONTyped(json, false);
}

export function ISearchEmployeeInfoDtoToJSONTyped(value?: ISearchEmployeeInfoDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'employeeId': value['employee_id'],
        'firstName': value['first_name'],
        'lastName': value['last_name'],
        'employerEmployeeId': value['employer_employee_id'],
        'partnerEmployeeId': value['partner_employee_id'],
        'ssn': value['ssn'],
        'status': value['status'],
    };
}

